import { render, staticRenderFns } from "./Endpoints.vue?vue&type=template&id=7a75bc5e&"
import script from "./Endpoints.vue?vue&type=script&lang=js&"
export * from "./Endpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports